/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

/**
 * Check if a value is null, undefined, or empty depending on the type of value
 * @param {any} value - the value to check
 * @returns the result of the check
 */
export const isNilOrEmpty = (value) => {
  if (value === null || value === undefined) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return value === '' || Number.isNaN(value);
}

/**
 * Gets the class for the app container. The base class is 'container-fluid', but other browser-specific classes might
 * be added depending on the user agent of the browser
 * @returns {string} the classes as a space-separated classname
 */
export const getAppContainerClassName = () => {
  const baseClassName = 'container-fluid';
  // add safari class for safari specific styles
  if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
    return `${baseClassName} safari`;
  } else if (navigator.userAgent.indexOf('Edge') !== -1) {
    return `${baseClassName} ie-edge`;
  } else if (navigator.userAgent.indexOf('IE 9') !== -1) {
    return `${baseClassName} ie-9`;
  }
  return baseClassName;
}